<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/abreu-vineyards')">Abreu Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/caymus-vineyards')">Caymus vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/christian-moueix-dominus')">Christian Moueix -
                        Dominus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/colgin-cellars')">Colgin Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/harlan-estates')">Harlan Estates
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/kapcsandy-winery')">Kapcsandy Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/opus-one')">Opus One
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/robert-mondovi-vineyards')">Robert Mondovi
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/usa/napa/scarecrow-wines')">Scarecrow Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/schrader-cellars')">Schrader Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/screaming-eagle')">Screaming Eagle
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Vini dello Spaventapasseri</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Alcuni sono nati per la grandezza e altri hanno la grandezza imposta su di loro. In quanto bevanda cult preferita di Hollywood, i vini Spaventapasseri rientrano sicuramente, ma meritatamente, in quest'ultima categoria.
                    </div>

                    <div class="howto-title2">Andiamo a vedere il Mago</div>
                    <div class="howto-text">
                        Originariamente di proprietà del compianto, grande, J.J. Cohn - ex vicepresidente ed esecutivo della MGM
                        produttore de Il mago di Oz (da cui il nome), Cohn acquistò il vigneto Inglenook come rifugio
                        per la sua famiglia quando il "trambusto di Hollywood" è diventato troppo. Mentre Cohn e la sua famiglia adoravano il
                        Fuga da Napa non c'era alcun interesse da parte loro a prendere parte alla produzione di vino, che
                        fu lasciato nelle mani dell'allora enologo di Inglenook John Daniels. Questo si è rivelato il migliore
                        cosa che Cohn ha fatto (o non ha fatto); Daniels ha scelto di non ripiantare così tanti portainnesti di fillossera
                        altri stavano facendo dopo la seconda guerra mondiale, preferendo invece proteggere e preservare le viti. Lo spaventapasseri lo è
                        oggi l'unica azienda vinicola di tutta la Napa che produce vini da viti di oltre 45 anni.
                    </div>

                    <div class="howto-title2">Non più in Kansas</div>
                    <div class="howto-text">
                        Dopo la morte di Cohn nel 1996, i suoi nipoti ereditarono la proprietà in tre parti uguali. Mentre
                        nipote (e fotografo di fama mondiale) Bret Lopez ha mantenuto le sue quote, le sue due sorelle hanno venduto le loro
                        a Francis Ford Coppola, che ha comportato la ristrutturazione e la ridenominazione dell'azienda ed è stata
                        in definitiva il primo passo sulla strada di mattoni gialli verso il successo di Spaventapasseri. Enologo Celia
                        Masyczek potrebbe anche essere considerato in parte responsabile della ripresa delle fortune, con lei
                        processi di miscelazione e invecchiamento unici un segreto gelosamente custodito. Lo Spaventapasseri ha prodotto il loro primo
                        bottiglia nel 2003 e oggi è una delle prime cinque aziende vinicole di Napa.
                    </div>

                    <div class="howto-title2">Un gioco da ragazzi</div>
                    <div class="howto-text">
                        A circa € 600, Spaventapasseri ha un prezzo simile a quelli di Lafite e Masseto. Tuttavia,
                        un'asta del 2014 ha venduto un lotto di 60 bottiglie di Toto's Opium Dream, Scena III dello Spaventapasseri per un
                        l'enorme cifra di 4.500 euro a bottiglia, rendendola la vendita più costosa di vini Napa da oltre un decennio. Se
                        questo si rivela troppo per le tue tasche, la tenuta produce anche un secondo vino, M. Etain che
                        mostra lo stesso corpo liscio di Spaventapasseri ma a una frazione del prezzo. Il nome, tipo
                        Spaventapasseri, è un bizzarro cenno al film più amato di Cohn ("etain" che significa stagno in francese).
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Vogelscheuchenweine</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Einige werden zu Größe geboren, anderen wird Größe aufgedrängt. Scarecrow-Weine sind Hollywoods beliebtestes Kultgetränk und gehören definitiv, aber zu Recht, zur letzteren Kategorie.
                    </div>

                    <div class="howto-title2">Wir machen uns auf den Weg, um den Zauberer zu sehen</div>
                    <div class="howto-text">
                        Ursprünglich im Besitz des verstorbenen großen J.J. Cohn – ehemaliger MGM-Vizepräsident und Geschäftsführer
                        Als Produzent von „Der Zauberer von Oz“ (daher der Name) kaufte Cohn das Weingut Inglenook als Rückzugsort
                        für seine Familie, als der „Hollywood-Trubel“ zu viel wurde. Während Cohn und seine Familie das liebten
                        Bei Napa Getaway bestand auf ihrer Seite kein Interesse daran, an der Weinproduktion teilzunehmen
                        wurde in den Händen von Inglenooks damaligem Winzer John Daniels belassen. Dies erwies sich als das Beste
                        was Cohn tat (oder nicht tat); Daniels entschied sich dafür, nicht so viele Reblaus-Wurzelstöcke neu zu bepflanzen
                        andere taten dies nach dem Zweiten Weltkrieg und zogen es stattdessen vor, die Reben zu schützen und zu erhalten. Vogelscheuche ist
                        Heute ist es das einzige Weingut in ganz Napa, das Weine aus über 45 Jahre alten Reben produziert.
                    </div>

                    <div class="howto-title2">Nicht mehr in Kansas</div>
                    <div class="howto-text">
                        Nach Cohns Tod im Jahr 1996 erbten seine Enkel das Anwesen zu drei gleichen Teilen. Während
                        Enkel (und weltberühmter Fotograf) Bret Lopez behielt seine Anteile, seine beiden Schwestern verkauften ihre
                        an Francis Ford Coppola, was die Umstrukturierung und Umbenennung des Unternehmens zur Folge hatte
                        letztendlich der erste Schritt auf dem gelben Backsteinweg zum Erfolg von Scarecrow. Winzerin Celia
                        Mit ihr könnte auch Masyczek als Mitverantwortlicher für den Vermögensaufschwung angesehen werden
                        Einzigartige Mischungs- und Alterungsprozesse sind ein streng gehütetes Geheimnis. Scarecrow brachte ihr erstes Exemplar hervor
                        Flasche im Jahr 2003 und zählt heute zu den fünf besten Weingütern Napas.
                    </div>

                    <div class="howto-title2">Ein Kinderspiel</div>
                    <div class="howto-text">
                        Mit etwa 600 € hat Scarecrow einen ähnlichen Preis wie Lafite und Masseto. Jedoch,
                        Bei einer Auktion im Jahr 2014 wurden 60 Flaschen „Toto’s Opium Dream“ von Scarecrow, Szene III, für einen Preis von 1,50 Euro verkauft
                        satte 4.500 € pro Flasche, was es zum teuersten Verkauf von Napa-Weinen seit über einem Jahrzehnt macht. Wenn
                        Das erweist sich als zu viel für Ihren Geldbeutel, das Weingut produziert auch einen Zweitwein, M. Etain
                        Zeigt den gleichen glatten Körper wie Scarecrow, jedoch zu einem Bruchteil des Preises. Der Name, wie
                        Scarecrow ist eine skurrile Anspielung auf Cohns beliebtesten Film („etain“ bedeutet auf Französisch „Zinn“).
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vins d'épouvantail</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Certains sont nés à la grandeur et d'autres ont la grandeur imposée sur eux. En tant que boisson culte préférée d'Hollywood, les vins Scarecrow sont très certainement, mais à juste titre, dans cette dernière catégorie.
                    </div>

                    <div class="howto-title2">Nous allons voir l'assistant</div>
                    <div class="howto-text">
                        Propriété à l'origine du regretté grand J.J. Cohn - ancien vice-président et directeur de la MGM
                        producteur du Magicien d'Oz (d'où le nom), Cohn a acheté le vignoble Inglenook comme lieu de retraite
                        pour sa famille lorsque «l'agitation hollywoodienne» est devenue trop importante. Tandis que Cohn et sa famille aimaient le
                        Napa escapade il n'y avait aucun intérêt de leur côté à participer à la production de vin, qui
                        a été laissé entre les mains du vigneron d'Inglenook, John Daniels. Cela s'est avéré être le meilleur
                        chose que Cohn a fait (ou n'a pas fait); Daniels a choisi de ne pas replanter avec le porte-greffe Phylloxera car beaucoup
                        d'autres le faisaient après la Seconde Guerre mondiale, préférant plutôt protéger et préserver les vignes. L'épouvantail est
                        aujourd'hui la seule cave de tout Napa produisant des vins à partir de vignes de plus de 45 ans.
                    </div>

                    <div class="howto-title2">Plus au Kansas</div>
                    <div class="howto-text">
                        Après la mort de Cohn en 1996, ses petits-enfants ont hérité du domaine en trois parts égales. Alors que
                        petit-fils (et photographe mondialement connu) Bret Lopez a gardé ses parts, ses deux sœurs ont vendu les leurs
                        à Francis Ford Coppola, qui a entraîné la restructuration et le changement de nom de l'entreprise et a été
                        finalement la première étape sur la route de briques jaunes vers le succès de Scarecrow. Célia vigneronne
                        Masyczek pourrait également être considérée comme en partie responsable de l'essor des fortunes, avec sa
                        processus d'assemblage et de vieillissement uniques un secret bien gardé. Scarecrow a produit son premier
                        bouteille en 2003 et se classe aujourd'hui parmi les cinq meilleurs établissements vinicoles de Napa.
                    </div>

                    <div class="howto-title2">Une évidence</div>
                    <div class="howto-text">
                        À environ 600 €, Scarecrow a un prix similaire à celui de Lafite et Masseto. Cependant,
                        une vente aux enchères de 2014 a vendu un lot de 60 bouteilles de Scarecrow’s Toto’s Opium Dream, Scene III pour un
                        4 500 € la bouteille, ce qui en fait la vente de vins Napa la plus chère depuis plus d'une décennie. Si
                        cela s'avère trop pour votre poche, le domaine produit également un second vin, M. Etain qui
                        montre le même corps lisse que Scarecrow mais à une fraction du prix. Le nom, comme
                        Scarecrow, est un clin d'œil décalé au film le plus apprécié de Cohn ("etain" qui signifie étain en français).
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Scarecrow Wines</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Some are born to greatness and others have greatness thrust upon them. As Hollywood’s favourite cult tipple, Scarecrow wines are most definitely, but deservingly, in the latter category.
                    </div>

                    <div class="howto-title2">We’re off to see the Wizard</div>
                    <div class="howto-text">
                        Originally owned by the late, great, J.J. Cohn - former MGM vice-president and executive
                        producer of The Wizard of Oz (hence the name), Cohn bought the Inglenook vineyard as a retreat
                        for his family when the “Hollywood hustle” became too much. While Cohn and his family loved the
                        Napa getaway there was no interest on their side of taking part in the wine production, which
                        was left in the hands of Inglenook’s then winemaker John Daniels. This proved to be the best
                        thing Cohn did (or didn’t) do; Daniels chose not to replant with Phylloxera rootstock as many
                        others were doing post-WWII, preferring instead to protect and preserve the vines. Scarecrow is
                        today the only winery in all of Napa producing wines from vines over 45-years old.
                    </div>

                    <div class="howto-title2">Not in Kansas anymore</div>
                    <div class="howto-text">
                        After Cohn died in 1996, his grandchildren inherited the estate in three equal parts. While
                        grandson (and world-famous photographer) Bret Lopez kept his shares, his two sisters sold theirs
                        to Francis Ford Coppola, which resulted in the restructuring and renaming of the company and was
                        ultimately the first step on the yellow brick road to Scarecrow’s success. Winemaker Celia
                        Masyczek could also be considered partly responsible for the upswing in fortunes, with her
                        unique blending and ageing processes a closely guarded secret. Scarecrow produced their first
                        bottle in 2003 and today ranks as one of Napa’s top five wineries.
                    </div>

                    <div class="howto-title2">A no-brainer</div>
                    <div class="howto-text">
                        At around €600, Scarecrow has a similar price point to the likes of Lafite and Masseto. However,
                        a 2014 auction sold a lot of 60 bottles of Scarecrow’s Toto’s Opium Dream, Scene III for a
                        whopping €4,500 a bottle, making it the most expensive sale of Napa wines for over a decade. If
                        this proves too much for your pocket, the estate also produces a second wine, M. Etain which
                        shows the same smooth body as Scarecrow but at a fraction of the price. The name, like
                        Scarecrow, is a quirky nod to Cohn’s best-loved film (“etain” meaning tin in French).
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ScarecrowWines",
    head: {
        title: 'Scarecrow Wines | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich, flavorful wines of Scarecrow Wines, a Napa Valley based wine producer known for their exceptional quality and meticulous winemaking techniques. Indulge in the perfect blend of tradition and innovation with every sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
            items: [
                {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
                {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
                {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
                {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
                {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
                {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
                {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
                {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
                {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
                {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
                {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
